import { useEffect } from "react";
import { publishTopBarUpdate, PageTitleInfo } from "utilities/publishBridgeEvent";

export default function useMobileTopBar({
    isSkipUpdate,
    title,
    subTitle,
    showBackButton,
    rightBarButton,
}: PageTitleInfo & { isSkipUpdate?: boolean }) {
    const rightBarButtonTitle = rightBarButton?.btnTitle;
    const rightBarButtonAction = rightBarButton?.btnAction;

    useEffect(() => {
        if (!isSkipUpdate) {
            publishTopBarUpdate({
                title,
                subTitle,
                showBackButton,
                ...(rightBarButtonTitle !== undefined && rightBarButtonAction !== undefined
                    ? {
                        rightBarButton: {
                            btnTitle: rightBarButtonTitle,
                            btnAction: rightBarButtonAction,
                        },
                    }
                    : {}),
            });
        }
    }, [
        isSkipUpdate,
        rightBarButtonAction,
        rightBarButtonTitle,
        showBackButton,
        subTitle,
        title,
    ]);
}
